export default "__VITE_ASSET__BSO2RVo9__"